/**
 * Избранное — правила экрана без React: порядок списка, переключение «сердца»
 * до ответа сервера и что значит отказ каталога по товару из списка.
 */
import type { FavoriteDto } from '@dorixona/api/favorites'
import { isApiError } from '@dorixona/api'
import { parseMs } from '@dorixona/utils'

/** Новые сверху. Метку без даты считаем самой старой — такой строке место внизу. */
export function newestFirst(list: FavoriteDto[]): FavoriteDto[] {
  return [...list].sort((a, b) => parseMs(b.added_at) - parseMs(a.added_at))
}

/**
 * Список после нажатия на «сердце» — то, что экран показывает сразу, не
 * дожидаясь сервера. Добавленный встаёт первым, повтор ничего не меняет.
 * Списка ещё нет (не успел прийти) — считаем его пустым.
 */
export function toggled(
  list: FavoriteDto[] | undefined,
  productId: number,
  on: boolean,
  addedAt: string,
): FavoriteDto[] {
  const rest = (list ?? []).filter((item) => item.product_id !== productId)
  return on ? [{ product_id: productId, added_at: addedAt }, ...rest] : rest
}

export function hasFavorite(list: FavoriteDto[] | undefined, productId: number): boolean {
  return (list ?? []).some((item) => item.product_id === productId)
}

/** Почему «сердце» не сработало: список полон — это стоит сказать отдельно. */
export function toggleFailure(error: unknown): 'full' | 'failed' {
  return isApiError(error) && error.code === 'validation_failed' ? 'full' : 'failed'
}
